import React, { useMemo } from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import groupEvents from './eventFactory';

import type { NodeEvent } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewEventsUpcomingProps {
  entities: Immutable.List<ImmutableEntity<NodeEvent>>;
  showAllOccurrences?: boolean,
}

const ViewEventsUpcoming: React.FC<ViewEventsUpcomingProps> = ({
  entities,
  showAllOccurrences,
}) => {
  const groupedEvents = useMemo(
    () => groupEvents({ events: entities, showAllOccurrences }),
    [entities, showAllOccurrences],
  );

  return (
    <div className="ViewEventsUpcoming">
      {Object.entries(groupedEvents).map(
        ([year, months]) => (
          <div className="ViewEventsUpcoming__year" key={year}>
            <h2>{year}</h2>
            {Object.entries(months).map(
              ([month, events]) => (
                <div className="ViewEventsUpcoming__month" key={month}>
                  <h3>{month}</h3>
                  <div className="ViewEventsUpcoming__events">
                    {events.map((event: ImmutableEntity<NodeEvent>, index) => {
                      const eventJS = event.toJS();

                      const id = eventJS.nid[0].value;
                      const uuid = eventJS.uuid[0].value;
                      const langcode = eventJS.langcode[0].value;
                      const key = `${uuid}:${langcode}`;

                      const delta = event.getIn(['delta']);

                      return (
                        <Node
                          key={key}
                          id={id}
                          entity={event}
                          viewMode="teaser"
                          index={delta}
                        />
                      );
                    })}
                  </div>
                </div>
              ),
            )}
          </div>
        ),
      )}
    </div>
  );
};

export default ViewEventsUpcoming;
